import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';

import {Flex, MenuButton as FeUiMenuButton} from '@spothero/ui';

const menuButtonStyles = {
    borderColor: 'white',
    backgroundColor: 'white',
    paddingX: 3,
    paddingY: 1,
    _hover: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
    },
    _active: {
        borderColor: 'gray.light',
        backgroundColor: 'gray.light',
        color: 'primary.default',
        _hover: {
            color: 'primary.600',
        },
    },
};

const MenuButton = forwardRef(({children, ...props}, ref) => {
    return (
        <FeUiMenuButton ref={ref} {...menuButtonStyles} {...props}>
            <Flex direction="row" alignItems="center">
                {children}
            </Flex>
        </FeUiMenuButton>
    );
});

MenuButton.propTypes = {
    children: PropTypes.node.isRequired,
};

export default MenuButton;
